import { render, staticRenderFns } from "./QuestionsWrapper.vue?vue&type=template&id=705bc592&scoped=true"
import script from "./QuestionsWrapper.vue?vue&type=script&lang=js"
export * from "./QuestionsWrapper.vue?vue&type=script&lang=js"
import style0 from "./QuestionsWrapper.vue?vue&type=style&index=0&id=705bc592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705bc592",
  null
  
)

export default component.exports